import { render, staticRenderFns } from "./HeroesPickResult.vue?vue&type=template&id=101853d0&"
import script from "./HeroesPickResult.vue?vue&type=script&lang=js&"
export * from "./HeroesPickResult.vue?vue&type=script&lang=js&"
import style0 from "./HeroesPickResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports